import { Button } from '@rrexpress/core';

interface ICancelConfirmationProps {
  onCancel: () => void;
  onSubmit: () => void;
}
export const CancelConfirmation: React.FC<ICancelConfirmationProps> = ({ onCancel, onSubmit }) => (
  <div className="space-y-6">
    <p>Apakah anda yakin ingin Cancel Transaksi ini?</p>
    <div className="flex justify-end space-x-2">
      <Button backgroundColor="red" onClick={onCancel}>Batal</Button>
      <Button variant="primary" onClick={onSubmit}>Ya</Button>
    </div>
  </div>
);
export default CancelConfirmation;
